import { useState, useEffect, useRef } from "react";
import { useAppSelector } from '../../../app/hooks';
import { icons } from '../../../assets';
import DashboardComponentWrapper from '../../../components/dashboard/DashboardComponentWrapper';
import DashboardNavItem from '../../../components/dashboard/DashboardNavItem/DashboardNavItem';
import TabComponent from '../../../components/ui/TabComponent';
import Table from '../../../components/ui/Table';
import { useNavigate, useParams } from "react-router-dom";
import TableActionsComponent from '../../../components/ui/Table/TableActionsComponent';
import Modal from '../../../components/ui/Modal';
import { useGetWorkflowsQuery, useRemoveUserFromWorkflowMutation } from '../../../features/shared/workflowApi';

const WorkflowUser = () => {
  const navigate = useNavigate();
  const tabComponents = {
    'Users': () => <UserTable />,
  };

  useEffect(() => {

  }, []);
  
  const navItemsObj = [
    {
      label: 'Go back',
      action: () => navigate(-1),
      bgColor: '#0898A0',
      img: icons.closeNav,
    }
  ];

  const renderNavItems = () => {
    return (
      <DashboardNavItem
        navItems={[]}
        navItemsObj={navItemsObj}
        tab={''}
        setTab={() => { }}
      />
    )
  }

  return (
      <DashboardComponentWrapper
        title="Workflow Users"
        pageDetails="View and Remove Users for your Workflow"
        renderNavItems={renderNavItems}
      >
        <>
          <TabComponent
            components={tabComponents}
          />
        </>
      </DashboardComponentWrapper>
  )
};

export default WorkflowUser;

const UserTable = () => {
  const params = useParams();
  
  const { data: workflowsResponse } = useGetWorkflowsQuery();
  const workflows = workflowsResponse?.data || [];
  
  const [users, setUsers] = useState<any[]>();
  const {user} = useAppSelector((state) => state.auth)
  const [toDelete, setToDelete] = useState<any>();
  
  const [removeUserMutation] = useRemoveUserFromWorkflowMutation();

  const handleRemoveUsers = (data) => {
    setToDelete(data)
  }

  useEffect(() => {
    if (params.id) {
      // @ts-ignore
      const workflow = workflows.find((item) => item.id == params.id);
      setUsers(workflow?.users || []);
    }
  }, [params.id, workflows]);


  const handleDeleteRequest = async () => {
    // @ts-ignore
    try {
      await removeUserMutation({ workflowId: params.id || "", userId: toDelete.userId }).unwrap();
      setToDelete(null);
    } catch (err) {
      // toast handles error
    }
  } 
  const header = [
    { field: 'firstName', headerName: 'First Name' },
    { field: 'lastName', headerName: 'Last Name' },
    { field: 'emailAddress', headerName: 'Email' },
    { field: 'roles', headerName: 'Roles', cellRenderer: ({ data }: any) => (<span>{ data?.roles?.join(' | ') }</span>)  },
    { field: 'viewOrDownloadEmployerSchedules', headerName: 'Can view or download Schedules' },
    { field: 'lastLogin', headerName: 'Last time Online'},
    { field: 'enable2Fa', headerName: 'Has 2FA on' },
    { field: 'address', headerName: 'Address'},
    {
      field: "paymentStatus",
      headerName: "Action",
      lockPosition: 'left',
      pinned: "right",
      type: "actions",
      cellRenderer: ({ data }: any) => 
        (
          <TableActionsComponent
            actions={[
              {
                component: (
                  <button key={'pfa'} onClick={() => handleRemoveUsers(data)} className='h-8 flex justify-center items-center !rounded-full bg-az-light-red text-az-teal !w-full px-4'>
                    <p className="w-fit text-left text-sm">Remove User</p>
                  </button>
                ),
              },
            ]}
          />
        )
    }
  ];
  return (
    <div className="accordion !w-full h-[65vh] text-left mt-6">
      {/* @ts-ignore */}
      <Table data={users} header={header}        
      />

      <Modal
        onClose={() => {
          setToDelete(null);
        }}
        open={toDelete}
        title={'Confirm Delete Action'}
        subTitle=""
        className="!h-fit !w-[95%] md:!w-[80%] !top-[50%]"
      >
        <div className="w-full">
          <div className="flex flex-col gap-2 justify-center items-end mb-3 ml-2">
            <h1 className="w-full my-3 text-center">Are you sure you want to remove this User from Workflow?</h1>
            <div className="flex flex-row gap-2 justify-center items-end w-full my-3">
              <button
                className='text-az-teal px-8 flex flex-row w-fit justify-around items-center h-10 bg-[transparent] border border-az-teal'
                onClick={() => setToDelete(null)}
              >
                No, Cancel Delete
              </button>
              <button onClick={() => handleDeleteRequest()} className="flex flex-row justify-center items-center px-5 h-10 bg-az-teal text-white rounded align-bottom">Yes, Delete</button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}